import { Phone, Timer, Target } from "lucide-react";
import { useCallTracker } from "@/components/app/CallTracker";

/**
 * Compact daily-progress strip shown at the top of the Telecaller dashboard.
 * Reads from the CallTracker context which already fetches /my-today.
 */
export default function TelecallerCallStats() {
  const { todayStats } = useCallTracker();
  if (!todayStats) return null;
  const { total_calls = 0, talk_time_formatted = "0s", avg_duration_formatted = "0s", target = 60 } = todayStats;
  const pct = Math.min(100, Math.round((total_calls / Math.max(1, target)) * 100));
  const bar = pct >= 80 ? "bg-emerald-500" : pct >= 40 ? "bg-amber-500" : "bg-red-500";
  return (
    <div className="card-surface p-4 mb-4" data-testid="tc-call-stats">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-3">
        <div className="flex items-center gap-2 text-white font-heading text-sm">
          <Phone className="w-4 h-4 text-amber-400"/> Today's Calls
        </div>
        <div className="text-[10px] uppercase tracking-widest text-slate-500">Target · {target}/day</div>
      </div>
      <div className="grid grid-cols-3 gap-2 mb-3">
        <div className="rounded-lg bg-slate-950/60 border border-white/5 px-3 py-2">
          <div className="text-[10px] uppercase tracking-widest text-slate-500 flex items-center gap-1"><Phone className="w-3 h-3"/>Calls</div>
          <div className="font-display text-xl text-white" data-testid="tc-calls-count">{total_calls}</div>
        </div>
        <div className="rounded-lg bg-slate-950/60 border border-white/5 px-3 py-2">
          <div className="text-[10px] uppercase tracking-widest text-slate-500 flex items-center gap-1"><Timer className="w-3 h-3"/>Talk Time</div>
          <div className="font-display text-xl text-white" data-testid="tc-talk-time">{talk_time_formatted}</div>
        </div>
        <div className="rounded-lg bg-slate-950/60 border border-white/5 px-3 py-2">
          <div className="text-[10px] uppercase tracking-widest text-slate-500 flex items-center gap-1"><Target className="w-3 h-3"/>Avg</div>
          <div className="font-display text-xl text-white" data-testid="tc-avg-time">{avg_duration_formatted}</div>
        </div>
      </div>
      <div className="h-2 bg-slate-800 rounded-full overflow-hidden">
        <div className={`h-full ${bar} transition-all`} style={{ width: `${pct}%` }}/>
      </div>
      <div className="flex justify-between text-[10px] text-slate-500 mt-1">
        <span>{total_calls} of {target}</span>
        <span data-testid="tc-target-pct">{pct}%</span>
      </div>
    </div>
  );
}
